import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import { PageClass, Page, IimportFraud } from 'src/app/shared/filters/filters';
import { OffersService } from '../../../../shared/services/admServices/offers.service';

@Component({
  selector: 'adm-dash-component',
  templateUrl: './fraud-component.html',
  styleUrls: ['./fraud-component.scss'],
})

export class offerfraudComponent implements OnInit{
  revertedData: any;
  fraudimportData: any;
  errorMessage = '';

  dropdownListAdvertiser : any[] = [];
  selectedItemsAdvertiser : any[] = [];
  dropdownSettingsAdvertiser: any = {};

  importFraud : IimportFraud = { clickTrackingIdHash:"", advertiserId: 0 };

  ColumnMode = ColumnMode;
  sendpage = new PageClass();
  pageSizeDefinition = 10;
  page = new Page();

  constructor(private offersService: OffersService, private toastrService: ToastrService ) {
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
  }

  ngOnInit() {
     // dropdownlist ADVERTISER
     this.dropdownListAdvertiser = [
      { item_id: 1, item_text: 'AdGate' },
      { item_id: 2, item_text: 'Affluent' },
      { item_id: 3, item_text: 'Aragon' },
      { item_id: 4, item_text: 'ClickDealer' },
      { item_id: 5, item_text: 'Mapstreet' },
      { item_id: 6, item_text: 'PocketMedia' },
      { item_id: 7, item_text: 'SmartResponseMedia' },  //
      { item_id: 8, item_text: 'Vanelo' },  //
      { item_id: 9, item_text: 'OpinionSample' },
      { item_id: 10, item_text: 'Wdigital' },
      { item_id: 11, item_text: 'AdstartMedia' },
      { item_id: 12, item_text: 'Mobitka' } //
    ];
    this.dropdownSettingsAdvertiser = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: false,
      closeDropDownOnSelection: true
    };

    this.setPage({ offset: 0 });
  }

  setPage(pageInfo){
    this.sendpage.pageNumber = pageInfo.offset+1;
    this.sendpage.pageSize = this.pageSizeDefinition;

    this.offersService.getFraudImport(this.sendpage)
      .subscribe(
      data => {
        this.page.totalElements = data.totalRecords;
        this.page.totalPages = data.totalPages;
        this.page.pageNumber = data.pageNumber-1;
        this.fraudimportData = data.data;
      },
      error => {
        console.log(error);
      });
  }

  onImport() {
    if(this.importFraud.advertiserId==0)
      this.toastrService.error('Select Advertiser', 'Error !');
    else
    {
      this.offersService.importFraudImport(this.importFraud).subscribe(
        response => {
          this.toastrService.success('Fraud data imported.', 'Success !');
          //this.toastrService.success('Fraud data imported.', 'Success !', { progressBar: true });
          this.setPage({ offset: 0 });
        },
        err => {
          console.log(err);
          this.errorMessage = err.error.errors[0].message;
          this.toastrService.error(`${this.errorMessage}`, 'Error !');
      });
    }
  }

  onItemSelectAdvertiser(item: any) {
    this.importFraud.advertiserId = this.selectedItemsAdvertiser[0].item_id;
  }

  onItemDeSelectType(items: any) {
    this.importFraud.advertiserId = 0;
  }
}
